import React, { PureComponent, ReactNode } from "react";
import "./SubpageToggler.css";

export interface SubpageTogglerOption {
  title: string;
  index: number;
}

interface Props {
  options: Array<SubpageTogglerOption>;
  selectedIndex: number;
  onSelection: (index: number) => void;
}

class SubpageToggler extends PureComponent<Props> {
  curryOnSelection = (ind: number) => () => {
    this.props.onSelection(ind);
  };

  render(): ReactNode {
    const { options, selectedIndex } = this.props;
    return (
      <div className="subpage-toggler-bar">
        {options.map((o) => {
          const selected = o.index === selectedIndex ? "selected" : "";
          const className = `subpage-toggler-option ${selected}`;
          return (
            <div className={className} key={o.title}>
              <button onClick={this.curryOnSelection(o.index)}>{o.title}</button>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SubpageToggler;
